import React, { useState } from 'react'
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { Visibility, VisibilityOff } from '@mui/icons-material';


export default function InputField( { id, placeholder, type, onChange, value, required = true, isValid = true, ...rest }) {
    const [showPassword, setShowPassword] = useState(false)

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    switch(type) {
        case 'password':
            return (<TextField
              fullWidth
              id={id}
              label={placeholder}
              value={value ? value : ''}
              onChange={onChange}
              name={id}
              required={required}
              error={!isValid}
              helperText={!isValid ? 'Please enter a valid value' : ''}
              sx={{ marginBottom: 2}}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: 
                    (<InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>)
                  
              }}
              
            />)


        case 'date':
            return (<DatePicker 
                onChange={onChange}
                inputFormat={"MM/DD/YYYY"}
                mask={"__/__/____"}
                value={value}
                label={placeholder}
                id={id}
                name={id}
                renderInput={(params) => <TextField 
                    fullWidth
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid value' : ''}
                    sx={{ marginBottom: 2}}
                    {...rest}
                    {...params} />}
            />)

        case 'time':
            return (<TimePicker 
                id={id}
                name={id}
                label={placeholder}
                value={value}
                onChange={onChange}
                renderInput={(params) => <TextField 
                    {...params}
                    fullWidth
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid time' : ''}
                    sx={{ marginBottom: 2}}
                />}
                disableOpenPicker
            />)
        case 'textarea':
            return (
                <TextField 
                    fullWidth
                    id={id}
                    label={placeholder}
                    value={value ? value : ''}
                    onChange={onChange}
                    name={id}
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid value' : ''}
                    sx={{ marginBottom: 2}}
                    multiline
                    rows={4}
                />
            )

        default:
            return (
                <TextField 
                    fullWidth
                    id={id}
                    label={placeholder}
                    value={value ? value : ''}
                    onChange={onChange}
                    name={id}
                    required={required}
                    error={!isValid}
                    helperText={!isValid ? 'Please enter a valid value' : ''}
                    sx={{ marginBottom: 2}}
                />)
    }
    
}